export default __webpack_public_path__ + "media/images/icons/icon_flag-abc0a5f6874c0737c69c0f47c94f8bdb.svg";